<template functional>
  <SocialImage
    title="Facebook"
    v-bind="data.attrs"
    :class="[data.class, data.staticClass]"
    channel="facebook"
    v-on="listeners"
  />
</template>

<script>
import SocialImage from './SocialImage';

export default {
  name: 'FacebookImage',
  components: {
    SocialImage,
  },
};
</script>

